import { ClientSafeConfig } from '@lib/context/config-context';
import { getServerRuntimeConfig } from '@lib/runtime-config';
import { AesGcmResult, decryptToStringAES, encryptStringAES } from '@lib/util/encrypt-util';

export const encryptRuntimeConfig = (config?: ClientSafeConfig) => {
  const encryptResponse = encryptStringAES(JSON.stringify(config ?? {}));
  return Buffer.from(JSON.stringify(encryptResponse), 'utf8').toString('base64');
};

export const getRuntimeConfig = (config?: ClientSafeConfig) => {
  const runtimeConfigAsBase64 =
    config || (typeof window !== 'undefined' ? (window as any).__RUNTIME_CONFIG__ : undefined);
  if (runtimeConfigAsBase64) {
    const data: AesGcmResult = JSON.parse(Buffer.from(runtimeConfigAsBase64, 'base64').toString('utf8'));
    const decryptData = decryptToStringAES(data.cipher, data.iv, data.tag);
    return JSON.parse(decryptData);
  }
  return getServerRuntimeConfig();
};
